"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.write = void 0;
var Codec = require("./../../io/codec");
/**
 * Write a {@link TopicValueConstraint} update constraint to the stream
 */
function write(bos, value) {
    Codec.writeByte(bos, value.operator);
    Codec.writeByte(bos, value.valueType);
    Codec.writeBytes(bos, value.bytes.asArray());
}
exports.write = write;
